import { DEFAULT_MAX_FORCE } from "../../neosmartpen/pencomm/pencomm_const";
import { PressureCalibration } from "../../neosmartpen/pencomm/PressureCalibration";
export var DotTypes;
(function (DotTypes) {
    DotTypes[DotTypes["PEN_DOWN"] = 1] = "PEN_DOWN";
    DotTypes[DotTypes["PEN_MOVE"] = 2] = "PEN_MOVE";
    DotTypes[DotTypes["PEN_UP"] = 3] = "PEN_UP";
    DotTypes[DotTypes["PEN_HOVER"] = 101] = "PEN_HOVER";
    DotTypes[DotTypes["PEN_ERROR"] = 999] = "PEN_ERROR";
})(DotTypes || (DotTypes = {}));
export var DOT_TYPE;
(function (DOT_TYPE) {
    DOT_TYPE[DOT_TYPE["none"] = 0] = "none";
    DOT_TYPE[DOT_TYPE["pendown"] = 1] = "pendown";
    DOT_TYPE[DOT_TYPE["penmove"] = 2] = "penmove";
    DOT_TYPE[DOT_TYPE["penup"] = 3] = "penup";
    DOT_TYPE[DOT_TYPE["penhover"] = 101] = "penhover";
    DOT_TYPE[DOT_TYPE["penerror"] = 999] = "penerror";
})(DOT_TYPE || (DOT_TYPE = {}));
export class Dot {
}
export class NeoDot extends Dot {
    constructor(dot) {
        super();
        if (dot) {
            const { dotType, deltaTime, time, f, x, y } = dot;
            this.dotType = dotType;
            this.deltaTime = deltaTime;
            this.time = time;
            this.f = f;
            this.x = x;
            this.y = y;
        }
    }
    /* #region  UWP용 Dot과 같은 형식을 위해 */
    get DotType() {
        return this.dotType;
    }
    set DotType(val) {
        this.dotType = val;
    }
    get X() { return this.x; }
    get Y() { return this.y; }
    get Force() { return this.f; }
}
export class NeoDotBuilder {
    constructor(maxForce) {
        this.RefindMaxForce = 1023;
        this.maxForce = -1;
        this.scale = -1.0;
        if (maxForce) {
            this.maxForce = maxForce;
            this.scale = this.RefindMaxForce / maxForce;
        }
        this.mDot = new NeoDot();
    }
    owner(owner) {
        this.mDot.Owner = owner;
        return this;
    }
    section(section) {
        this.mDot.Section = section;
        return this;
    }
    note(note) {
        this.mDot.Note = note;
        return this;
    }
    page(page) {
        this.mDot.Page = page;
        return this;
    }
    timestamp(timestamp) {
        this.mDot.Timestamp = timestamp;
        return this;
    }
    coord(x, y) {
        this.mDot.x = x;
        this.mDot.y = y;
        return this;
    }
    tilt(x, y) {
        this.mDot.TiltX = x;
        this.mDot.TiltY = y;
        return this;
    }
    twist(twist) {
        this.mDot.Twist = twist;
        return this;
    }
    force(force) {
        if (this.maxForce === -1)
            // normalize, 2022/06/29
            this.mDot.f = force / DEFAULT_MAX_FORCE;
        else {
            this.mDot.f = Math.round((force * this.scale)); // 반올림
            if (PressureCalibration.Instance.Factor != null)
                this.mDot.f = PressureCalibration.Instance.Factor[this.mDot.Force];
            // normalize, 2022/06/29
            this.mDot.f = this.mDot.f / this.maxForce;
        }
        return this;
    }
    dotType(dotType) {
        this.mDot.DotType = dotType;
        return this;
    }
    color(color) {
        this.mDot.Color = color;
        return this;
    }
    Build() {
        return this.mDot;
    }
}
//# sourceMappingURL=NeoDot.js.map